// extracted by mini-css-extract-plugin
export default {"main":"dashboard_main__J-RYo","title":"dashboard_title__SPAfH"};